import { IrisDMSFile } from '@iris/common/modules/dms/models/IrisDMSFile';
import { IrisDMSFolder } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IrisDMSFolderOrFile, isFolder } from '../utils/file.utils';
import { computed, signal } from '@angular/core';
import { isEqual } from 'lodash';

export class DmsGridTemplateBase<T = IrisDMSFolderOrFile> implements ICellRendererAngularComp {
  readonly params = signal<ICellRendererParams<T>>(null, { equal: isEqual });
  readonly node = signal<IRowNode<T>>(null, { equal: isEqual });
  readonly value = computed(() => (this.params()?.valueFormatted || (this.params()?.value as string)) ?? '');
  readonly gridApi = computed(() => this.params()?.api);

  readonly data = signal<T>(null, { equal: isEqual });
  readonly file = computed(() => {
    const data = this.data();
    if (!data || isFolder(data as IrisDMSFolderOrFile)) return null;
    return new IrisDMSFile(data);
  });

  readonly folder = computed(() => {
    const data = this.data();
    if (!data || this.file()) return null;
    return new IrisDMSFolder(data);
  });

  agInit(params: ICellRendererParams<T>): void {
    this.params.set(params);
    this.node.set(params.node);
    this.data.set(params.data);
  }

  refresh(params: ICellRendererParams<T>): boolean {
    this.agInit(params);
    return true;
  }
}
